import { useEntityActionAllowed } from "@/hooks/use-entity-action-allowed";

const ENABLE_ACTION = {
	JobType: "EnableJobType",
	TicketType: "EnableTicketType",
	AssetType: "EnableAssetType",
	RecordType: "EnableRecordType",
} as const;

const DISABLE_ACTION = {
	JobType: "DisableJobType",
	TicketType: "DisableTicketType",
	AssetType: "DisableAssetType",
	RecordType: "DisableRecordType",
} as const;

export type TypeAccessEntity = keyof typeof ENABLE_ACTION;

/**
 * Access-tab saves call Enable*Type and Disable*Type, not Edit*Type.
 * The pencil is shown only after one of those checks allows it.
 */
export function useTypeAccessEditAllowed(
	entityType: TypeAccessEntity,
	entityId: string | undefined,
): { allowed: boolean; isPending: boolean } {
	const enabled = Boolean(entityId);
	const enable = useEntityActionAllowed({
		name: ENABLE_ACTION[entityType],
		entityType,
		entityId,
		enabled,
	});
	const disable = useEntityActionAllowed({
		name: DISABLE_ACTION[entityType],
		entityType,
		entityId,
		enabled,
	});

	return {
		allowed: enable.allowed || disable.allowed,
		isPending: enabled && (enable.isPending || disable.isPending),
	};
}
